import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { CircularLoader } from '../CircularLoader/CircularLoader';
import { FULLSCREEN_LOADER_SIZE } from './constants/fullscreenLoaderSize';

export const CircularProgressFullScreen = (): ReactNode => (
  <CircularLoader
    color="var(--primary-color)"
    size={FULLSCREEN_LOADER_SIZE}
    testId={locator.components.circularProgressFullScreen.root}
    fullscreen
  />
);
